import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  ButtonGroup,
  Grid2,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  FormHelperText,
} from "@mui/material";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../components/MaterialTypography";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../components/MaterialBox";
import MaterialInput from "../../components/MaterialInput";
import MaterialButton from "../../components/MaterialButton";
import { useEffect, useState } from "react";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MaterialSnackbar from "../../components/MaterialSnackbar";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
const Permission = () => {
  const data = sessionStorage.getItem("user");
  const parsedData = JSON.parse(data);

  console.log(parsedData, "pardata");

  const encodedId = parsedData?.id;
  const encryted = btoa(encodedId);
  console.log(parsedData, "lv");

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  const nav = useNavigate();
  const [dialogopen, setdialogopen] = useState(false);
  const [Snackbar, setSnackbar] = useState(false);
  const [updateid, setupdateid] = useState("");

  const addmutation = `
     
 mutation CreatePermission($input: CreatePermissionInput!) { 

  createPermission(input: $input) { 

    permission { 

      id 

      user { 

        id 

        empid 

        firstName 

      } 

      permissionOn 

      permissionFrom 

      permissionTill 

      reason 

      status 

      teamApproval 

      hrApproval 

      balanceHours 

      createdAt 

    } 

    balanceHours 

    message 

    success 

    error 

  } 

} 
     
     `;

  const updatemutation = `
       
 mutation UpdatePermission(  

  $permissionId: ID!,   

  $permissionOn: Date,   

  $permissionFrom: Time,   

  $permissionTill: Time,   

  $reason: String  

) {  

  updatePermission(  

    permissionId: $permissionId,   

    permissionOn: $permissionOn,   

    permissionFrom: $permissionFrom,   

    permissionTill: $permissionTill,   

    reason: $reason  

  ) {  

    permission {  

      id  

      permissionOn  

      permissionFrom  

      permissionTill  

      reason  

      balanceHours  

      status  

    }  

    balanceHours  

    message  

    success  

    error  

  }  

} 
     
     
     `;

  const getpermission = `
 query PermissionRequestById($id: ID!){ 

  permissionById(id: $id){ 

    data{ 

      user{ 

      id 

      firstName 

      lastName 

      email 

    } 

    permissionOn 

    permissionFrom 

    permissionTill 
    reason
    balanceHours
    status 
    
    approvalStatus{ 

      id 

      approver{ 

        id 

        firstName 

        lastName 

        email 

      } 

      status 

    } 

     

    } 

    message 

    success 

    error 

  } 

} 
     
 
     `;

  const fetchpermissionhours = `
      

    query PermissionRequestByUserId($userid: ID!){ 

  permissionsByUser(userId: $userid){ 

    data{ 

      user{ 

      id 

      firstName 

      lastName 

      email 

    } 

    permissionOn 

    permissionFrom 

    permissionTill 

    status 
    balanceHours

    approvalStatus{ 

      id 

      approver{ 

        id 

        firstName 

        lastName 

        email 

      } 

      status 

    } 

     

    } 

    message 

    success 

    error 

  } 

} 
     
     
     `;

  const [remaininghours, setremaininghours] = useState("");
  const [permission, setPermission] = useState({
    userId: encodedId,
    permissionOn: "",
    permissionFrom: "",
    permissionTill: "",
    permissionTillStatus: "",
    reason: "",
    reasonStatus: "",
  });

  useEffect(() => {
    const fetchpermission = async () => {
      try {
        const response = await axios.post(
          BASEURL,
          {
            query: fetchpermissionhours,
            variables: {
              userid: parsedData?.id,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setremaininghours(4);

        console.log(response.data, "fetper");

        let val = response.data.data.permissionsByUser.data[0].balanceHours;
        console.log(val, "balance hrss");

        setremaininghours(val);
      } catch (error) {
        console.log(error, "err");
      }
    };

    fetchpermission();
  }, []);

  const [iseditatable, seteditable] = useState(true);

  useEffect(() => {
    if (id) {
      console.log("inside effect");
      const fetchpermission = async () => {
        try {
          const response = await axios.post(
            BASEURL,
            {
              query: getpermission,
              variables: { id },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          console.log(response.data.data.permissionById?.data[0], "respd");

          setremaininghours(
            response.data.data.permissionById?.data[0].balanceHours
          );

          setPermission({
            permissionId: response.data.data.permissionById?.data[0].id,
            permissionOn:
              response.data.data.permissionById.data[0].permissionOn,
            permissionFrom:
              response.data.data.permissionById.data[0].permissionFrom,
            permissionTill:
              response.data.data.permissionById.data[0].permissionTill,
            reason: response.data.data.permissionById.data[0].reason,
          });
          seteditable(false);
        } catch (error) {
          console.log(error, "err");
        }
      };

      fetchpermission();
    }
  }, [id]);

  const [errors, setErrors] = useState({
    TotalPermissionsHours: false,
    permissionOn: false,
    permissionFrom: false,
    permissionTill: false,
    reason: false,
    timeOrder: false, // New error state for time order validation
  });

  useEffect(() => {
    if (permission.permissionFrom && permission.permissionTill) {
      const from = new Date(`2023-01-01T${permission.permissionFrom}`);
      const till = new Date(`2023-01-01T${permission.permissionTill}`);
      const diff = (till - from) / (1000 * 60); // Difference in minutes

      if (diff > 120) {
        console.log("⚠️ Alert: Time difference should not exceed 2 hours!");
        setPermission({
          ...permission,
          permissionTillStatus: "error",
        });
      } else {
        console.clear();
        setPermission({
          ...permission,
          permissionTillStatus: "success",
        });
      }
    }
  }, [permission.permissionFrom, permission.permissionTill]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    console.log("name:", name);
    console.log("Till:", value);

    // Update permission state
    setPermission((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validation logic
    let isValid = true;

    if (name === "remaininghours" && (isNaN(value) || value <= 0)) {
      isValid = false;
    }
    if (name === "permissionOn" && !value) {
      isValid = false;
    }
    if (name === "permissionTill" && !value) {
      isValid = false;
    }
    // if (name === "reason" && !value) {
    //   isValid = false;
    // }

    let timeOrderValid = true;
    let fromTime =
      name === "permissionFrom" ? value : permission.permissionFrom;
    let tillTime =
      name === "permissionTill" ? value : permission.permissionTill;

    if (fromTime && tillTime && fromTime >= tillTime) {
      timeOrderValid = false;
    }

    // Update error state
    setErrors((prev) => ({
      ...prev,
      [name]: !isValid,
      timeOrder: !timeOrderValid,
    }));
  };

  const handleDepartmentDatachange = (event) => {
    let departmentState = { ...permission };
    switch (event.target.name) {
      case "reason": {
        const alphaNumberLengthRegex = new RegExp("^([A-Za-z ]{1,40})$");
        if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
          departmentState[event.target.name + "Status"] = "success";
        } else {
          departmentState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      default:
        break;
    }
    departmentState[event.target.name] = event.target.value;
    setPermission(departmentState);
  };

  const isFormValid = () => {
    return (
      remaininghours &&
      permission.permissionOn &&
      permission.permissionFrom &&
      permission.permissionTill &&
      permission.reason &&
      !Object.values(errors).includes(true)
    );
  };

  console.log(errors, "err");

  console.log("Form Submitted Successfully");
  const handleSubmit = async () => {
    setdialogopen(true);
  };

  //handleclose

  const handleclose = () => {
    setdialogopen(false);
  };

  const confirmsubmit = async () => {
    console.log("insidesubmit");
    if (isFormValid()) {
      console.log("Form Submitted Successfully", permission);

      if (id) {
        try {
          const response = await axios.post(
            BASEURL,
            {
              query: updatemutation,
              variables: {
                permissionId: id,
                permissionOn: permission?.permissionOn,

                permissionFrom: permission?.permissionFrom,

                permissionTill: permission?.permissionTill,
                teamleaderId: parsedData.teamleader,

                reason: permission?.reason,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response?.data?.data?.updatePermission !== null) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Permission updated successfully!",
              showConfirmButton: false,
              timer: 2500,
            });
            nav("/permission");
          } else {
            Swal.fire({
              icon: "error",
              title: response?.data?.errors[0]?.message,
              // text: response?.data?.error?.message,
            });
          }
        } catch (error) {
          console.log(error, "err");
        }
      } else {
        //create

        try {
          const response = await axios.post(
            BASEURL,
            {
              query: addmutation,
              variables: {
                input: {
                  userId: permission?.userId,

                  permissionOn: permission?.permissionOn,

                  permissionFrom: permission?.permissionFrom,

                  permissionTill: permission?.permissionTill,

                  reason: permission?.reason,
                  teamleaderId: parsedData.teamleader,

                  screenName: "Permission Approval",
                },
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          console.log(response, "resp");

          let data = response.data.data.createPermission.success;
          let message = response.data.data.createPermission.message;
          let Errordata = response.data.errors;

          if (data) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Permission Requested successfully!",
              showConfirmButton: false,
              timer: 2500,
            });

            nav("/permission");
          } else if (!data) {
            Swal.fire({
              position: "center",
              icon: "error",
              title: message,
              showConfirmButton: false,
              timer: 4500,
            });
          } else if (
            Errordata[0]?.message ==
            "You already have a pending permission request."
          ) {
            Swal.fire({
              position: "center",
              icon: "error",
              title: Errordata[0]?.message,
              showConfirmButton: false,
              timer: 4500,
            });
          } else if (
            Errordata[0]?.message ==
            "Your permission request overlaps with an existing pending or approved leave request."
          ) {
            Swal.fire({
              position: "center",
              icon: "error",
              title: Errordata[0]?.message,
              showConfirmButton: false,
              timer: 4500,
            });
          }
          console.log("datadata:", data);
        } catch (error) {
          console.log(error, "err");
        }
      }
    } else {
      console.log("Please fill all fields correctly.");
    }

    setdialogopen(false);
    //  setSnackbar(true)
  };
  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onCancelAction = () => {
    nav("/permission");
  };

  return (
    <DashboardLayout>
      <ConfirmationDialog
        open={confirmationDialog.open}
        title={confirmationDialog.title}
        message={confirmationDialog.message}
        showCancel={confirmationDialog.showCancel}
        showConfirm={confirmationDialog.showConfirm}
        customSection={confirmationDialog.customSection}
        onConfirm={confirmationDialog.onConfirm}
        onCancel={confirmationDialog.onCancel}
      />
      <Dialog open={dialogopen} onClose={handleclose}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          Are you sure do you want to submit your details.
        </DialogContent>
        <DialogActions>
          <Button onClick={handleclose}>Cancel</Button>
          <Button onClick={confirmsubmit}>Confirm</Button>
        </DialogActions>
      </Dialog>

      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Permission
                </MaterialTypography>
              </Stack>
              {id && (
                <ButtonGroup
                  variant="outlined"
                  aria-label="Loading button group"
                >
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={() => seteditable(true)}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </MaterialButton>

                  {/* <MaterialButton
               variant="gradient"
               color="dark"
             onClick={""}
               startIcon={<DeleteIcon />}
             >
               Delete
             </MaterialButton> */}
                </ButtonGroup>
              )}

              {/* { id&&<MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={()=>seteditable(true)}
            >
              Edit
            </MaterialButton>
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
             
              onClick={""}
            >
              Delete
            </MaterialButton>
          </MaterialBox>} */}
            </Stack>
          }
        />

        <CardContent>
          <Stack direction="row" spacing={1}>
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Permission Details
            </MaterialTypography>
          </Stack>

          <MaterialBox>
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Total Permissions Hours{" "}
                    <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="remaining"
                  disabled
                  value={remaininghours}
                  onChange={handleChange}
                  error={errors.TotalPermissionsHours}
                  success={!errors.TotalPermissionsHours}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Permission From <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="permissionFrom"
                  type="time"
                  value={permission.permissionFrom}
                  onChange={handleChange}
                  error={errors.permissionFrom}
                  disabled={!iseditatable}
                  success={
                    permission.permissionFrom &&
                    !errors.permissionFrom &&
                    !errors.timeOrder
                  }
                />
                {/* {
                 errors.timeOrder? <span style={{color:"red",fontSize:"15px"}}>
                   from time should be lesser than till time
                  </span>:null
                } */}
              </Grid2>

              <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Permission Till <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="permissionTill"
                  type="time"
                  value={permission.permissionTill}
                  onChange={handleChange}
                  disabled={!iseditatable}
                  error={
                    errors.permissionTill ||
                    errors.timeOrder ||
                    permission.permissionTillStatus == "error"
                  }
                  success={
                    permission.permissionTill &&
                    !errors.permissionTill &&
                    !errors.timeOrder
                  }
                />
                {errors.timeOrder ? (
                  <span style={{ color: "red", fontSize: "15px" }}>
                    From time should be lesser than till time
                  </span>
                ) : null}

                {permission.permissionTillStatus == "error" && (
                  <span style={{ color: "red", fontSize: "15px" }}>
                    Time difference should not exceed 2 hours!
                  </span>
                )}
              </Grid2>

              <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Permission On <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  name="permissionOn"
                  type="date"
                  value={permission.permissionOn}
                  onChange={handleChange}
                  error={errors.permissionOn}
                  disabled={!iseditatable}
                  success={permission.permissionOn && !errors.permissionOn}
                  inputProps={{
                    min: new Date().toISOString().split("T")[0],
                  }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Reason <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  multiline
                  rows={7}
                  name="reason"
                  // placeholder="eg. IT"
                  value={permission.reason}
                  onChange={handleDepartmentDatachange}
                  disabled={!iseditatable}
                  error={permission.reasonStatus === "error"}
                  success={permission.reasonStatus === "success"}
                  //   success={roleData.descriptionStatus === "success"}
                  //   disabled={togglePage.view === true ? true : false}
                />
                {permission.reasonStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Department Name should be a maximum of 40 characters long
                      and can contain only alphabets.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
            </Grid2>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            {iseditatable && (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handlecancel}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2, marginLeft: "4px" }}
                  variant="gradient"
                  color="dark"
                  disabled={!isFormValid()}
                  onClick={() => handleSubmit()}
                >
                  Submit
                </MaterialButton>
              </>
            )}
          </MaterialBox>
        </CardContent>

        <MaterialSnackbar
          color="success"
          icon={<NotificationsIcon />}
          title="Message"
          content="You have been submitted successfully"
          open={Snackbar}
          close={() => {
            setSnackbar(false);
            nav("/permission");
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default Permission;